import type {
  TemplateDetailDTO,
  TemplateSummaryDTO,
} from '../services/api'
import type { TemplateCardData, TemplateCategory, TemplateSpec } from './templateTypes'

/** API summary → gallery card data (live-URL preview + labels). */
export function toCardData(dto: TemplateSummaryDTO): TemplateCardData {
  return {
    slug: dto.slug,
    name: dto.name,
    category: dto.category as TemplateCategory,
    oneLiner: dto.one_liner,
    liveDemoUrl: dto.live_demo_url,
    previewAlt: dto.preview_alt,
  }
}

/** API detail → the full TemplateSpec the detail view renders. */
export function toTemplateSpec(dto: TemplateDetailDTO): TemplateSpec {
  return {
    slug: dto.slug,
    name: dto.name,
    category: dto.category as TemplateCategory,
    oneLiner: dto.one_liner,
    description: dto.description,
    previewImage: dto.preview_image ?? '',
    previewImage2x: dto.preview_image_2x ?? '',
    ogImage: dto.og_image ?? '',
    previewAlt: dto.preview_alt ?? '',
    liveDemoUrl: dto.live_demo_url || undefined,
    prompt: dto.prompt,
    builds: dto.builds ?? [],
    stack: dto.stack ?? [],
    needsDatabase: dto.needs_database,
    followUpPrompts: dto.follow_up_prompts ?? [],
    date: dto.date ?? '',
    updated: dto.updated,
  }
}
